<template>
  <div>
    <div class="card mt-2 shadow-none">
      <div class="card-header border-bottom-0">
        <ul class="nav nav-tabs card-header-tabs" role="tablist">
          <li v-for="(grupo, i) in value" :key="grupo.id" class="nav-item">
            <a
              class="nav-link"
              :class="{ active: i === 0 }"
              :id="`nav_${grupo.id}`"
              data-toggle="tab"
              :href="`#tab_${grupo.id}`"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >{{ grupo.nombre }}</a
            >
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div
            v-for="(grupo, i) in value"
            :key="grupo.id"
            class="tab-pane fade pt-2"
            :class="{ 'show active': i === 0 }"
            :id="`tab_${grupo.id}`"
            role="tabpanel"
            aria-labelledby="nav-home-tab"
          >
            <div class="row">
              <div
                class="form-row col-lg-4 col-md-6 col-sm-12 mb-3"
                v-for="antecedente in grupo.antecedentes"
                :key="antecedente.id"
              >
                <div class="w-100 border p-2 rounded">
                  <buttonsCheck
                    :antecedente="antecedente"
                    :label="antecedente.descripcion"
                    :type="antecedente.tipo_antecedente.codigo"
                    :value="antecedente.antecedente_usuario.valor"
                    @input="handleValueChange(antecedente, $event)"
                  />
                  <div v-if="hasRdaConfig(antecedente) && antecedente.antecedente_usuario.valor !== 'NO' && antecedente.antecedente_usuario.valor !== ''" class="mt-2 text-right">
                    <button
                      type="button"
                      class="btn btn-xs btn-primary"
                      @click="openModal(antecedente)"
                    >
                      <i class="fa fa-plus"></i> Detallar Antecedentes ({{ getDetallesCount(antecedente) }})
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para configurar detalles -->
    <AntecedenteDetalleModal
      :show="showModal"
      :antecedente="activeAntecedente"
      @close="closeModal"
      @save="saveDetails"
    />
  </div>
</template>

<script>
import buttonsCheck from "../../views/historias/antecedente/buttonsCheckAntecedentes.vue";
import AntecedenteDetalleModal from "./AntecedenteDetalleModal.vue";

export default {
  name: 'AntecedenteComponent',
  components: {
    buttonsCheck,
    AntecedenteDetalleModal
  },
  props: {
    // Array de grupos de antecedentes
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      activeAntecedente: null
    };
  },
  methods: {
    hasRdaConfig(antecedente) {
      if (!antecedente.rda_configs || antecedente.rda_configs.length === 0) {
        return false;
      }
      return !antecedente.rda_configs.some(config => config.tipo_detalle === 'RISK_FACTOR');
    },
    getDetallesCount(antecedente) {
      const details = antecedente.antecedente_usuario && antecedente.antecedente_usuario.detalles;
      return Array.isArray(details) ? details.length : 0;
    },
    handleValueChange(antecedente, newValue) {
      if (newValue === '') {
        newValue = 'SI';
      }
      this.$set(antecedente.antecedente_usuario, 'valor', newValue);
    },
    openModal(antecedente) {
      this.activeAntecedente = antecedente;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.activeAntecedente = null;
    },
    saveDetails(data) {
      if (this.activeAntecedente) {
        this.$set(this.activeAntecedente.antecedente_usuario, 'detalles', data.detalles);
      }
      this.closeModal();
    }
  }
};
</script>
